import React, { useState, FormEvent } from "react";
import {
  NewsLetterContainer,
  NewsLetterBox,
  NewsLetterButton,
  NewsLetterUpdate,
  NewsLetterLorem,
  NewsLetterInput,
  InputField,
  SubmitButton,
  // NotificationContainer,
  // NotificationText
} from "./NewsLetter.styled";
import { useMutation } from "@apollo/client";
import { joinSubscription } from "../../graphql/mutations/joinWaitlist";
import ConfettiPage from "../ConfettiPage/ConfettiPage.component";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";
import { environment } from "../../env";
import { ToastContainer, toast } from "react-toastify";

type Subscribe = {
  email: string;
};

interface NewsLetterProps {
  newsLetterText: string;
}
const NewsLetter: React.FC<NewsLetterProps> = ({ newsLetterText }) => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const [data, setData] = useState<Subscribe>({
    email: "",
  });
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const [showError, setShowError] = useState<string>("");
  const [joinSubscriptionAction, { loading, error, data: saved }] =
    useMutation(joinSubscription);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const enteredEmail = event.target.value;
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enteredEmail);
    setData({ email: enteredEmail });
    setIsValidEmail(isValidEmail);
    setShowError("");
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isValidEmail) {
      try {
        const response = await joinSubscriptionAction({
          variables: {
            sendNotificationTemplateId: environment.joinSubscriptionTempId,
            sendNotificationEmails: [data.email],
          },
        });
        console.log("Subscription response:", response);
        setShowError("");
        toast.success("You’ve successfully subscribed to our news letter", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setData({ email: "" });
      } catch (error) {
        console.error("Error sending notification:", error);
      }
    }
  };

  const handleClose = () => {
    setData({ email: "" });
    setShowNotification(false);
    // setShowError(false);
  };

  return (
    <NewsLetterContainer>
      <NewsLetterBox>
        <NewsLetterButton>
          <p>
            {t("SUBSCRIBE", {
              lng: currentLocale,
            })}
          </p>
        </NewsLetterButton>
        <NewsLetterUpdate>
          <h2>
            {t("Subscribe to our newsletter to get", {
              lng: currentLocale,
            })}
            <br />
            {t("latest updates", {
              lng: currentLocale,
            })}
          </h2>
        </NewsLetterUpdate>
        {showNotification && !loading && saved && (
          <ConfettiPage handleCloseCofetti={handleClose} />
        )}
        <NewsLetterLorem>
          <p>{newsLetterText}</p>
        </NewsLetterLorem>
      </NewsLetterBox>

      <NewsLetterInput onSubmit={handleSubmit}>
        <InputField
          type="email"
          placeholder={t("Enter your email address", {
            lng: currentLocale,
          })}
          value={data.email}
          onChange={handleChange}
        />
        <SubmitButton type="submit">
          {t("Send", {
            lng: currentLocale,
          })}
        </SubmitButton>
      </NewsLetterInput>
      {!isValidEmail && (
        <p style={{ color: "red" }}>Please enter a valid email address.</p>
      )}

      {/*{showNotification && (*/}
      {/*  <NotificationContainer>*/}
      {/*    <NotificationText>You’ve successfully subscribed to our newsletter</NotificationText>*/}
      {/*  </NotificationContainer>*/}
      {/*)}*/}

      {/*{showError && (*/}
      {/*  <NotificationContainer style={{ backgroundColor: '#e73314' }}>*/}
      {/*    <NotificationText style={{ color: 'white' }}>Error: Please enter a valid email address</NotificationText>*/}
      {/*  </NotificationContainer>*/}
      {/*)}*/}
    </NewsLetterContainer>
  );
};

export default NewsLetter;
